import { datadogRum } from 'root/datadog/datadogRum';

export default class Monitoring {
  /**
   * Sends DataDog events through pageActions
   *
   * @param {String} eventName Name of the event
   * @param {String} source Where the event come from, using the Class name is recommended
   * @param {Object} cAttributes The custom attributes you want to submit with this event
   */
  static addEvent(eventName: string, source: string, cAttributes: { [key: string]: any } = {}) {
    datadogRum.addAction(eventName, { source, ...cAttributes });
  }

  /**
   * Sends notice or log in case of error
   * to DataDog
   *
   * @param {Error|string} error object thrown when runtime errors occur
   * @param {String} source Where the event come from, using the Class name is recommended
   * @param {Object} cAttributes The custom attributes you want to submit with this event
   */
  static addError(error: Error | string, source?: string, cAttributes: Record<string, any> = {}) {
    datadogRum.addError(error, { source, ...cAttributes });
  }
}

window.Monitoring = Monitoring;

export { Monitoring };
